import { Observable } from 'rxjs';
import { Directive } from '@angular/core';

@Directive()
export abstract class BeforeTrainingStart {
    abstract saveBeforeStart(): Observable<any>;
}
